import * as echarts from "echarts";
import { lazyBMapApiLoaderInstance } from "vue-bmap-gl";

/**
 * 生成指定范围的随机数
 * @param {number} min - 最小值（包含）
 * @param {number} max - 最大值（不包含）
 * @param {number} decimal - 保留小数位数（默认 0，即整数）
 * @returns {number|string} 随机数（小数位数>0 时返回字符串，需转数字可加 Number()）
 */
export function getRandomNum(min, max, decimal = 0) {
  const num = Math.random() * (max - min) + min;
  return decimal > 0 ? num.toFixed(decimal) : Math.floor(num);
}

export function handlePercentage(value) {
  const num = Number(value);
  return isNaN(num) ? 0 : Math.max(0, Math.min(100, num));
}

export function numToChinese(number) {
  const numMap = "零一二三四五六七八九";
  const unitMap = ["", "十", "百", "千", "万", "十万", "百万", "千万", "亿"];

  let result = "";

  const numStr = number.toString();
  const length = numStr.length;

  for (let i = 0; i < length; i++) {
    const num = parseInt(numStr[i]);

    if (num !== 0) {
      result += numMap[num] + unitMap[length - i - 1];
    } else {
      const nextNum = parseInt(numStr[i + 1]);

      if (nextNum !== 0) {
        result += numMap[num];
      }
    }
  }

  return result;
}

export function getDay() {
  const dateObj = new Date();
  const year = dateObj.getFullYear(); // 获取当前年份
  const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取当前月份，其中需要将月份加1，因为月份是从0开始计数的
  const day = ("0" + dateObj.getDate()).slice(-2); // 获取当前日期
  const formattedDate = `${year}-${month}-${day}`; // 格式化日期
  // console.log(formattedDate); // 输出当前时间的年月日

  return formattedDate;
}

export function getDayHMY() {
  const dateObj = new Date();
  const year = dateObj.getFullYear(); // 获取当前年份
  const month = ("0" + (dateObj.getMonth() + 1)).slice(-2); // 获取当前月份，其中需要将月份加1，因为月份是从0开始计数的
  const day = ("0" + dateObj.getDate()).slice(-2); // 获取当前日期
  const formattedDate = `${year}-${month}-${day} 00:00:00`; // 格式化日期
  // console.log(formattedDate); // 输出当前时间的年月日

  return formattedDate;
}

export function getCompare(value1, value2) {
  if (parseInt(value1) < parseInt(value2)) {
    return "否";
  } else {
    return "是";
  }
}

export function surroundingRockValue(num) {
  switch (num) {
    case "2":
      return "100";
    case "3":
      return "200";
    case "4":
      return "75";
    case "5":
      return "75";
    case "6":
      return "100";
    default:
      break;
  }
}

export function surroundingRoc(num) {
  switch (num) {
    case "1":
      return "Ⅰ";
    case "2":
      return "Ⅱ";
    case "3":
      return "Ⅲ";
    case "4":
      return "Ⅳ";
    case "5":
      return "Ⅴ";
    case "6":
      return "Ⅵ";
    default:
      break;
  }
}

export function surroundingRockValues(num) {
  switch (num) {
    case "2":
      return "100";
    case "3":
      return "100";
    case "4":
      return "75";
    case "5":
      return "75";
    default:
      break;
  }
}

export function surroundingRockValuesy(num) {
  switch (num) {
    case "2":
      return "200";
    case "3":
      return "200";
    case "4":
      return "100";
    case "5":
      return "180";
    default:
      break;
  }
}

// 日期差异计算函数
export function getDateDifference(date1, date2) {
  // 获取两个日期的时间戳
  var timeStamp1 = date1.getTime();
  var timeStamp2 = date2.getTime();

  // 计算差异的毫秒数
  var difference = Math.abs(timeStamp1 - timeStamp2);

  // 将毫秒数转换为天数
  var days = Math.floor(difference / (1000 * 60 * 60 * 24));

  return days;
}

// 获取完整日期
export function formatDateAll(dateString, format) {
  const date = new Date(dateString);
  const formattedDate = format
    .replace(/YYYY/g, date.getFullYear())
    .replace(/MM/g, String(date.getMonth() + 1).padStart(2, "0"))
    .replace(/DD/g, String(date.getDate()).padStart(2, "0"))
    .replace(/hh/g, String(date.getHours()).padStart(2, "0"))
    .replace(/mm/g, String(date.getMinutes()).padStart(2, "0"))
    .replace(/ss/g, String(date.getSeconds()).padStart(2, "0"));
  return formattedDate;
}

export function lastSevenDayData() {
  const today = new Date();
  const lastSevenDays = [];
  for (let i = 0; i < 7; i++) {
    const date = new Date(today);
    // 计算前一天的日期
    const previousDate = new Date(date);
    previousDate.setDate(date.getDate() - i);
    // 计算前一天的日期
    const previousDates = new Date(date);
    previousDates.setDate(date.getDate() - i + 1);

    const year = previousDate.getFullYear();
    const month = String(previousDate.getMonth() + 1).padStart(2, "0");
    const day = String(previousDate.getDate()).padStart(2, "0");
    const days = String(previousDates.getDate()).padStart(2, "0");

    const formattedDate = `${month}-${day}`;
    const formattedFullDate = `${year}-${month}-${day}`;
    const formattedFullDates = `${year}-${month}-${days}`;

    lastSevenDays.push({
      date: formattedDate, // 日期字符串，格式为 'MM-DD'
      startTime: formattedFullDate, // 开始时间，格式为 'yyyy-mm-dd'
      endTime: formattedFullDates, // 结束时间，格式为 'yyyy-mm-dd'
    });
  }
  return lastSevenDays;
}

// 获取年月日
export function formatDates(date) {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    year = d.getFullYear();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return year + "年" + month + "月" + day + "日";
}

export function formatDateDay(date) {
  let d = new Date(date),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;

  return month + "-" + day;
}

export function formatDateHis() {
  const dateObj = new Date();
  let d = new Date(dateObj),
    month = "" + (d.getMonth() + 1),
    day = "" + d.getDate(),
    // 获取小时和分钟
    hours = "" + d.getHours(),
    minutes = "" + d.getMinutes();

  if (month.length < 2) month = "0" + month;
  if (day.length < 2) day = "0" + day;
  // 确保小时和分钟为两位数
  if (hours.length < 2) hours = "0" + hours;
  if (minutes.length < 2) minutes = "0" + minutes;

  return `${hours}:${minutes}`;
}

// 获取年月日
export function formatDate(dateString, format) {
  const date = new Date(dateString);
  const formattedDate = format
    .replace(/YYYY/g, date.getFullYear())
    .replace(/MM/g, String(date.getMonth() + 1).padStart(2, "0"))
    .replace(/DD/g, String(date.getDate()).padStart(2, "0"));
  return formattedDate;
}

// ... 已有代码 ...
// 添加时间格式化函数
export function formatTimeHM(dateTime) {
  if (!dateTime) return "";
  const date = new Date(dateTime);
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
}

// 统计图颜色
export function EChartsColor() {
  return [
    "#fff",
    "#33FF57",
    "#3357FF",
    "#FF33A1",
    "#6A5ACD",
    "#FF8C00",
    "#8A2BE2",
    "#20B2AA",
    "#FFD700",
    "#C71585",
  ];
}

// 转换成亿
export function convertToBillion(number) {
  return number / 100000000;
}

// 随机数
export function getRandomNumber(num) {
  return Math.floor(Math.random() * num) + 1;
}

// 随机数 4--9
export function getRandomNumbers(i, j) {
  return Math.floor(Math.random() * (i - j + 1)) + j;
}

//创建标注颜色
export function createMarkerIcon(color) {
  // 创建canvas元素
  var canvas = document.createElement("canvas");
  var ctx = canvas.getContext("2d");
  canvas.width = 100;
  canvas.height = 100;
  ctx.fillStyle = color;
  ctx.beginPath();
  ctx.arc(50, 50, 50, 0, Math.PI * 2); // 绘制一个圆形
  ctx.fill();

  // 将canvas转换为图片
  var iconImg = new BMapGL.Icon(canvas.toDataURL(), new BMapGL.Size(20, 20));
  return iconImg;
}

// 创建标注和线
/*
  创建点标记
  var points = [
      new BMapGL.Point(117.211998,36.392386),
      new BMapGL.Point(117.201998,36.342386),
      new BMapGL.Point(117.201998,36.322386)
  ];

*/
export function createMarkerPolyline(points, map) {
  let marker1Arry = [];
  var myIcons = createMarkerIcon("#4e6ef2");
  var polyline = new BMapGL.Polyline(points, {
    strokeColor: "blue", // 设置曲线颜色为蓝色
    strokeWeight: 6, // 设置线宽为6
    strokeOpacity: 0.5, // 设置线透明度为0.5
    strokeStyle: "dashed",
  });
  map.addOverlay(polyline);

  points.forEach(function (item) {
    let marker1 = new BMapGL.Marker(item, { icon: myIcons });
    marker1Arry.push(marker1);
    map.addOverlay(marker1);
  });

  return marker1Arry;
}

// 覆盖物
/**
  var pStart = new BMapGL.Point(117.201998, 36.392386);
  var pEnd = new BMapGL.Point(117.301998, 36.352386);
 */
export function createMarkerPolylines(pStart, pEnd, map, GroundOverlayIcon) {
  var bounds = new BMapGL.Bounds(
    new BMapGL.Point(pStart.lng, pEnd.lat),
    new BMapGL.Point(pEnd.lng, pStart.lat),
  );
  var opts = { opacity: 0.5 };
  var imgOverlay = new BMapGL.GroundOverlay(
    bounds,
    {
      type: "image",
      url: GroundOverlayIcon,
      opacity: 1,
      zIndex: 9999,
    },
    opts,
  );
  map.addOverlay(imgOverlay);
  map.getPanes().markerPane.style.zIndex = 500;
}

// 信息窗口
/**
  var pStart = new BMapGL.Point(117.201998, 36.392386);
  var pEnd = new BMapGL.Point(117.301998, 36.352386);
 */
export function createMarkerInfoWindow(
  title,
  message,
  content,
  marker,
  points,
  map,
) {
  // 弹窗标注
  var opts = {
    width: 200, // 信息窗口宽度
    height: 100, // 信息窗口高度
    title: title, // 信息窗口标题
    message: message,
  };
  var infoWindow = new BMapGL.InfoWindow(content, opts); // 创建信息窗口对象
  marker.addEventListener("click", function () {
    map.openInfoWindow(infoWindow, points); //开启信息窗口
  });
}

// 创建图标
export function createMarkerInfoPointIcon(PointIcon, points) {
  var myIcon = new BMapGL.Icon(PointIcon, new BMapGL.Size(20, 20));
  let ltd = getRandomNumber();
  var pt = new BMapGL.Point(117.251998, 322386);
  var markers = new BMapGL.Marker(points, {
    icon: myIcon,
  });
  return markers;
}

// 转大地坐标系（传前两个参数表示从百度坐标转，传后两个参数表示从高德坐标转）
export function coordinateTransformation(bdLon, bdLat, marsLon, marsLat) {
  const mars_point = { lon: 0, lat: 0 };
  if (bdLon && bdLat) {
    const x_pi = (3.141592653589793 * 3000.0) / 180.0;
    //百度坐标转成火星坐标
    const x = bdLon - 0.0065;
    const y = bdLat - 0.006;
    const z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
    const theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
    mars_point.lon = z * Math.cos(theta);
    mars_point.lat = z * Math.sin(theta);
  } else if (marsLon && marsLat) {
    mars_point.lon = marsLon;
    mars_point.lat = marsLat;
  } else {
    console.debug("coordinateTransformation方法传参错误！");
    return { lng: undefined, lat: undefined };
  }
  //把火星坐标GCJ02转地球坐标系WGS84
  const gcjLon = mars_point.lon;
  const gcjLat = mars_point.lat;
  const d = delta(gcjLon, gcjLat);
  function delta(lon, lat) {
    const PI = 3.141592653589793;
    const a = 6378245.0;
    const ee = 0.006693421622965943;
    let dLon = transformLon(lon - 105.0, lat - 35.0);
    let dLat = transformLat(lon - 105.0, lat - 35.0);
    const radLat = (lat / 180.0) * PI;
    let magic = Math.sin(radLat);
    magic = 1 - ee * magic * magic;
    const sqrtMagic = Math.sqrt(magic);
    dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * PI);
    dLat = (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * PI);
    return {
      lon: dLon,
      lat: dLat,
    };
  }
  function transformLon(x, y) {
    const PI = 3.141592653589793;
    let ret =
      300.0 +
      x +
      2.0 * y +
      0.1 * x * x +
      0.1 * x * y +
      0.1 * Math.sqrt(Math.abs(x));
    ret +=
      ((20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0) /
      3.0;
    ret +=
      ((20.0 * Math.sin(x * PI) + 40.0 * Math.sin((x / 3.0) * PI)) * 2.0) / 3.0;
    ret +=
      ((150.0 * Math.sin((x / 12.0) * PI) + 300.0 * Math.sin((x / 30.0) * PI)) *
        2.0) /
      3.0;
    return ret;
  }
  function transformLat(x, y) {
    const PI = 3.141592653589793;
    let ret =
      -100.0 +
      2.0 * x +
      3.0 * y +
      0.2 * y * y +
      0.1 * x * y +
      0.2 * Math.sqrt(Math.abs(x));
    ret +=
      ((20.0 * Math.sin(6.0 * x * PI) + 20.0 * Math.sin(2.0 * x * PI)) * 2.0) /
      3.0;
    ret +=
      ((20.0 * Math.sin(y * PI) + 40.0 * Math.sin((y / 3.0) * PI)) * 2.0) / 3.0;
    ret +=
      ((160.0 * Math.sin((y / 12.0) * PI) + 320 * Math.sin((y * PI) / 30.0)) *
        2.0) /
      3.0;
    return ret;
  }

  return {
    lng: gcjLon - d.lon,
    lat: gcjLat - d.lat,
  };
}

// 替换铭感字
export function lhTunnelNameRiel(name) {
  return name
    .replace("西山", "测试A")
    .replace("杏花峪", "测试B")
    .replace("安子岭", "测试C")
    .replace("济", "东")
    .replace("济", "东")
    .replace("济南", "测东")
    .replace("泰安", "峰东");
}

// 将时间戳转换为 Date 对象 判断是否过期
export function targetDate(timestamp) {
  // 将时间戳转换为 Date 对象
  const targetDate = new Date(timestamp);
  // 获取当前日期
  const currentDate = new Date();

  // 输出转换后的日期
  console.log("时间戳转换后的日期: ", targetDate);

  // 比较日期
  if (targetDate < currentDate) {
    console.log("该时间戳对应的日期已过期" + currentDate);
    return false;
  } else {
    console.log("该时间戳对应的日期未过期" + currentDate);
    return true;
  }
}

export function IsIntNun(str) {
  if (str === undefined) {
    return 0.0;
  } else if (str === null) {
    return 0.0;
  } else if (isNaN(str)) {
    return 0.0;
  } else if (str === "") {
    return 0.0;
  } else {
    return str;
  }
}

// 新增里程转换方法
export function formatMileage(mileage) {
  if (typeof mileage !== "number") {
    mileage = parseFloat(mileage);
  }
  if (isNaN(mileage)) {
    return "";
  }
  const km = Math.floor(mileage / 1000);
  const m = mileage % 1000;
  return `DK${km}+${String(m).padStart(3, "0")}`;
}

export function formatMileageUint(mileage, uint) {
  if (typeof mileage !== "number") {
    mileage = parseFloat(mileage);
  }
  if (isNaN(mileage)) {
    return "";
  }
  const km = Math.floor(mileage / 1000);
  const m = mileage % 1000;
  return uint + `+${String(m).padStart(3, "0")}`;
}

// 设置带过期时间的localStorage
export function setLocalStorageWithExpiry(key, value, expiryInMinutes) {
  const now = new Date();
  // 计算过期时间（当前时间 + 分钟数转换为毫秒）
  const expiryTime = now.getTime() + expiryInMinutes * 60 * 1000;

  // 存储数据和过期时间
  const item = {
    value: value,
    expiry: expiryTime,
  };

  localStorage.setItem(key, JSON.stringify(item));
}

// 获取带过期时间的localStorage
export function getLocalStorageWithExpiry(key) {
  // 校验key的有效性
  if (typeof key !== "string" || key.trim() === "") {
    console.warn("Invalid storage key:", key);
    return null;
  }

  try {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    // 解析前先快速判断结构合法性（避免无效JSON解析耗时）
    if (!itemStr.includes('"expiry"') || !itemStr.includes('"value"')) {
      localStorage.removeItem(key);
      return null;
    }

    const item = JSON.parse(itemStr);
    // 验证数据结构完整性
    if (
      typeof item !== "object" ||
      item === null ||
      !("expiry" in item) ||
      !("value" in item)
    ) {
      localStorage.removeItem(key);
      return null;
    }

    const now = Date.now(); // 比new Date().getTime()更高效
    // 检查过期时间有效性和是否过期
    if (typeof item.expiry !== "number" || now > item.expiry) {
      localStorage.removeItem(key);
      return null;
    }

    return item.value;
  } catch (error) {
    // 出错时清除无效数据，避免下次重复出错
    try {
      localStorage.removeItem(key);
    } catch (cleanupError) {
      console.error("Failed to clean up invalid storage item:", cleanupError);
    }
    console.error("Error processing localStorage item:", error);
    return null;
  }
}

// 登录成功后设置token及过期时间
export function handleLoginSuccess(response) {
  // 设置token，有效期为24小时（可根据需求调整）
  this.setLocalStorageWithExpiry("updateToken", this.token, 24 * 60);
}

// 生成echarts配置项 --- 饼图
export function itemPie(legendData, xAxisData, seriesData) {
  let option = {
    tooltip: {
      trigger: "axis",
      appendToBody: true, // 👈 添加这一行
      textStyle: {
        color: "#666",
        fontSize: "0.875rem",
        formatter: "{a} <br/>{b} : {c} ({d}%)",
      },
    },
    legend: {
      //  orient: 'vertical', // 横向排列（适配下方显示）
      x: "center", // 水平居中
      y: "bottom", // 固定在底部

      textStyle: {
        color: "#fff", // 图例文字设为白色
        fontSize: 12, // 可选：调整文字大小，避免拥挤
      },
      formatter: function (params) {
        // 自定义图例文本格式：标题 ---- 数量
        // 遍历series.data，匹配当前图例项的数量
        let target = option.series[0].data.find((item) => item.name === params);
        return `${params}   ${target.value} 人  `; // 拼接成目标格式
      },
      icon: "circle", // 核心修改：将图例图标从方框改为圆点
      itemWidth: 8, // 可选：缩小圆点直径（原方框宽度12，圆点建议8-10更协调）
      itemHeight: 8, // 与itemWidth保持一致，确保圆点是正圆形
      padding: [10, 0, 0, 0], // 可选：上下留白，避免贴近图表或底部
      data: legendData,
    },
    toolbox: {
      show: false,
      feature: {
        mark: { show: true },
        dataView: { show: true, readOnly: false },
        magicType: {
          show: true,
          type: ["pie", "funnel"],
          option: {
            funnel: {
              x: "25%",
              width: "50%",
              funnelAlign: "center",
              max: 1548,
            },
          },
        },
        restore: { show: true },
        saveAsImage: { show: true },
      },
    },
    calculable: true,
    series: [
      {
        // 去掉 name: '访问来源' 这一行，彻底移除该名称
        name: "",
        type: "pie",
        center: ["50%", "40%"], // 调整位置避免超出
        radius: ["40%", "60%"],
        itemStyle: {
          normal: {
            label: {
              show: false,
            },
            labelLine: {
              show: false,
            },
          },
          emphasis: {
            label: {
              show: false,
              position: "center",
              textStyle: {
                fontSize: "30",
                fontWeight: "bold",
              },
              // 优化：通过 params 直接获取当前高亮数据的 value，避免依赖外部 option
              formatter: function (params) {
                return params.value;
              },
            },
          },
        },
        data: seriesData,
      },
    ],
  };
  return option;
}

// 生成echarts配置项 --- 折线图
export function axisLine(legendData, xAxisData, seriesData) {
  return {
    tooltip: {
      trigger: "axis",
    },
    legend: {
      show: false,
      data: legendData,
    },
    toolbox: {
      show: false,
      feature: {
        mark: { show: true },
        dataView: { show: true, readOnly: false },
        magicType: { show: true, type: ["line", "bar", "stack", "tiled"] },
        restore: { show: true },
        saveAsImage: { show: true },
      },
    },
    calculable: true,
    xAxis: [
      {
        type: "category",
        boundaryGap: false,
        data: xAxisData,
      },
    ],
    yAxis: [
      {
        type: "value",
      },
    ],
    series: seriesData,
  };
}
